export default __webpack_public_path__ + "static/media/chairman.6beb85d1.jpg";